import styled from 'styled-components';
import { s } from './VIPReport.style';
import { IReportData } from '../../../service/quant/Quant';

const quantcheckData = [
  {
    strategy: '저평가주 (宙)',
    description: '시세보다 저렴하게 나온 물건',
    profit: '단기 매각 차익 가능성이 높음',
    applicable: 'undervaluedStock',
  },
  {
    strategy: '공시지가보다낮주 (宙)',
    description: '공시지가보다 낮은 가격에 매수 가능',
    profit: '공공가치보다 싸게 사는 안정성 높은 투자',
    applicable: 'belowOfficialPrc',
  },
  {
    strategy: '전세가보다낮주 (宙)',
    description: '전세보증금보다 싸게 매입 가능',
    profit: '실입주 없이 임대 수익 확보 가능',
    applicable: 'belowJeonsePrc',
  },
  {
    strategy: '평균보다낮주 (宙)',
    description: '인근 평균보다 낮은 가격의 물건',
    profit: '상대적 저평가 → 시세 회복 기대',
    applicable: 'belowAvgPrc',
  },
  {
    strategy: '하자없주 (宙)',
    description: '권리상 하자 없음(대항력, 임차인 등)',
    profit: '법률 리스크 없이 깔끔한 낙찰 가능',
    applicable: 'defectFree',
  },
  {
    strategy: '시세차익주 (宙)',
    description: '차익 실현 가능성이 높은 물건',
    profit: '중단기 매각으로 실현 가능한 수익 전략',
    applicable: 'prcGainPotential',
  },
  {
    strategy: '저평가부실채권주 (宙)',
    description: '시세보다 저렴한 NPL (부실채권) 물건',
    profit: '권리 분석만 통과하면 고수익 가능',
    applicable: 'undervaluedStockNpl',
  },
  {
    strategy: '소액투자주 (宙)',
    description: '3천만 원 이하 소액 투자 가능',
    profit: '자금 부담 적고 초보자에게 적합',
    applicable: 'smallInvestment',
  },
  {
    strategy: '시세상승주 (宙)',
    description: '최근 실거래가 상승세인 지역 물건',
    profit: '단기 시세 상승 기대감 + 매각 유리',
    applicable: 'prcIncreasePotential',
  },
  {
    strategy: '이자보다월세주 (宙)',
    description: '월세 수익 > 대출이자인 물건',
    profit: '레버리지 투자에서도 현금흐름 확보 가능',
    applicable: 'wolseOverInterest',
  },
  {
    strategy: '전세우위주 (宙)',
    description: '전세 수요가 강한 지역 물건',
    profit: '공실 리스크 낮고 안정적인 임대 수익',
    applicable: '',
  },
  {
    strategy: '월세우위주 (宙)',
    description: '월세 임대수익이 유리한 지역 물건',
    profit: '이자 부담보다 높은 월 현금흐름 가능',
    applicable: '',
  },
];

const QuantCheck = ({ data }: { data?: IReportData['info'] }) => {
  return (
    <s.Div style={{ paddingBottom: '120px' }}>
      <s.Title>📊퀀트 투자전략 해당 여부</s.Title>
      <CheckList>
        {quantcheckData.map((item, index) => (
          <CheckContainer key={index}>
            <ColumnContent>
              <RowContent
                style={{
                  width: '100%',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                }}
              >
                <span>{item.strategy}</span>
                {data &&
                data[item.applicable as 'wolseOverInterest'] === 'Y' ? (
                  <span
                    style={{
                      fontSize: '12px',
                      fontWeight: '500',
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '4px',
                      alignItems: 'center',
                    }}
                  >
                    <Check />
                    해당
                  </span>
                ) : (
                  <span
                    style={{
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#37383C47',
                      display: 'flex',
                      flexDirection: 'row',
                      gap: '4px',
                      alignItems: 'center',
                    }}
                  >
                    <Dash />
                    미해당
                  </span>
                )}
              </RowContent>
              {item.description}
            </ColumnContent>

            <ProfitContainer>
              <img
                src="/assets/images/quant/diamond_20.svg"
                style={{ width: '20px', height: '20px' }}
              />
              {item.profit}
            </ProfitContainer>
          </CheckContainer>
        ))}
      </CheckList>
    </s.Div>
  );
};

export default QuantCheck;

const Check = () => (
  <svg
    width="10"
    height="8"
    viewBox="0 0 10 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.47493 0.806574C9.41295 0.744088 9.33922 0.694492 9.25798 0.660646C9.17674 0.6268 9.0896 0.609375 9.00159 0.609375C8.91359 0.609375 8.82645 0.6268 8.74521 0.660646C8.66397 0.694492 8.59024 0.744088 8.52826 0.806574L3.56159 5.77991L1.47493 3.68657C1.41058 3.62441 1.33462 3.57554 1.25138 3.54274C1.16815 3.50993 1.07926 3.49385 0.989809 3.49539C0.900355 3.49694 0.812082 3.51609 0.73003 3.55176C0.647978 3.58742 0.573753 3.63889 0.511594 3.70324C0.449435 3.76759 0.400559 3.84355 0.367756 3.92679C0.334954 4.01002 0.318867 4.09891 0.320414 4.18836C0.321962 4.27781 0.341114 4.36609 0.376776 4.44814C0.412439 4.53019 0.463913 4.60441 0.528261 4.66657L3.08826 7.22657C3.15024 7.28906 3.22397 7.33866 3.30521 7.3725C3.38645 7.40635 3.47359 7.42377 3.56159 7.42377C3.6496 7.42377 3.73674 7.40635 3.81798 7.3725C3.89922 7.33866 3.97295 7.28906 4.03493 7.22657L9.47493 1.78657C9.5426 1.72415 9.5966 1.64838 9.63354 1.56404C9.67048 1.47971 9.68955 1.38864 9.68955 1.29657C9.68955 1.20451 9.67048 1.11344 9.63354 1.0291C9.5966 0.94477 9.5426 0.869002 9.47493 0.806574Z"
      fill="#008AFF"
    />
  </svg>
);

const Dash = () => (
  <svg
    width="10"
    height="2"
    viewBox="0 0 10 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="10" height="2" rx="1" fill="#37383C" fill-opacity="0.28" />
  </svg>
);

const CheckList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const CheckContainer = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-radius: 16px;
  border: 1px solid #e5e8ea;
`;

const RowContent = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #008aff;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

const ColumnContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
  font-weight: 500;
  color: #616161;
`;

const ProfitContainer = styled.div`
  font-size: 13px;
  font-weight: 500;
  color: #222222;
  display: flex;
  flex-direction: row;
  gap: 4px;
  border-radius: 8px;
  padding: 8px;
  background-color: rgba(112, 115, 124, 0.08);
  align-items: center;
`;
